import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import SurveyForm from '../components/SurveyForm';
import Footer from '../components/Footer';
import { decryptData } from '../utils/crypto';

const SurveyPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(location.search);
  const encryptedData = searchParams.get('data');
  
  let email: string | null = null;
  let lancamento: number = 1;

  try {
    if (encryptedData) {
      const decryptedData = decryptData(encryptedData);
      email = decryptedData.email;
      lancamento = decryptedData.lancamento;
    }
  } catch (error) {
    console.error('Error decrypting data:', error);
    // Em caso de erro na descriptografia, redireciona para a página inicial
    navigate('/inscricao', { replace: true });
  }

  // Efeito para validação e redirecionamento
  if (!email) {
    navigate('/inscricao', { replace: true });
    return null;
  }

  return (
    <div className="font-inter text-[#0d0d0d] bg-[#f2f0f0]">
      <main>
        <section className="bg-gradient-to-r from-[#0d0d0d] to-[#1a1a1a] text-white py-16 md:py-20">
          <div className="container mx-auto px-4 md:px-8 max-w-7xl">
            <div className="max-w-4xl mx-auto text-center">
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-12 bg-gradient-to-r from-[#ffffff] to-[#f20587] text-transparent bg-clip-text animate-gradient">
                Pesquisa Rápida
              </h1>

              <p className="text-xl md:text-2xl mb-8 text-center max-w-3xl mx-auto font-medium leading-relaxed bg-gradient-to-r from-white to-white/90 bg-clip-text">
                Suas respostas nos ajudam a melhorar o conteúdo para você!
              </p>

              {/* Survey Form */}
              <SurveyForm email={email} lancamento={lancamento} />
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default SurveyPage; 